import { StyleSheet, Dimensions, Platform } from 'react-native';
import config from '../../config';

const { width: windowWidth } = Dimensions.get('window');

const itemFeatureHeight = 240;
const widthFeaturePadding = 8;
const itemFeatureWidth =
  Platform.OS === 'web' ? 345 : windowWidth - (60 + widthFeaturePadding);
const totalFeatureItemWidth = itemFeatureWidth + widthFeaturePadding;

const itemWidthPadding = 20;
const itemHeight = 205;
const itemWidth = 219;
// const itemCardPadding = 20;

const totalItemWidth = itemWidth + itemWidthPadding;

const widthMiniPadding = 12;
const itemMiniHeight = 55;
const itemMiniWidth = 70;
const totalMiniItemWidth = itemMiniWidth + widthMiniPadding;

const featureItemHeight =
  itemFeatureWidth * config.theme.advert.imageHeightRatio; // 194;

const advertImageWidth = 206;

const styles = StyleSheet.create({
  list: {
    flex: 1,
    width: '100%',
  },
  slideContainer: {
    // height: itemHeight,
    width: totalItemWidth,
    marginStart: 5,
    marginEnd: 16,
    marginBottom: 20,
    borderColor: 'transparent',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.6,
    shadowRadius: 3,
    elevation: 0, // android makes elevation calculations which get larger from orignal element :(
    ...Platform.select({
      ios: {},
      android: {
        borderWidth: 0.5,
        borderColor: '#efefef',
        borderBottomWidth: 2,
        borderRadius: 1,
      },
    }),
  },
  slideTagsSelected: {
    backgroundColor: config.theme.brandColor,
  },
  slideTagsSelectedText: {
    color: 'white',
  },
  slideFeatureContainer: {
    height: featureItemHeight,
    width: totalFeatureItemWidth,
    margin: 0,
  },
  slideTextContainer: {
    width: itemWidth,
    marginTop: 5,
  },
  slideFeatureTextContainer: {
    marginTop: 65 - itemFeatureHeight,
    width: itemFeatureWidth,
  },
  slideTagsTextContainer: {
    marginTop: 0,
    width: itemMiniWidth,
  },
  slideText: {
    color: config.theme.advert.headingTextColor,
  },
  slideTextLarge: {
    marginTop: 1,
    fontSize: 14,
    fontWeight: 'bold',
  },
  slideTextMedium: {
    fontSize: 11,
    fontWeight: '300',
    marginTop: 7,
  },
  slideFeatureText: {
    color: '#ffffff',
    backgroundColor: '#00000060',
    alignSelf: 'flex-start',
    padding: 7.5,
    paddingRight: 5,
    paddingLeft: 15,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  slideFeatureTextLarge: {
    fontSize: 20,
  },
  slideFeatureTextMedium: {
    fontSize: 14,
  },
  slideMiniText: {
    color: '#000000',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 0,
    paddingRight: 0,
    paddingLeft: 0,
    fontSize: 12,
    fontWeight: '500',
    marginBottom: 0,
    marginTop: 5,
  },
  slideMiniContainer: {
    marginTop: 15,
    width: totalMiniItemWidth,
    alignItems: 'center',
    marginBottom: 20,
  },
  slideMiniContainerSingleLine: {
    width: undefined,
    marginHorizontal: 10,
  },
  slideMiniTextContainer: {
    marginTop: 0,
    width: itemMiniWidth,
  },
  slideMiniTextContainerSingleLine: {
    width: undefined,
    alignItems: 'center',
  },
  slideMiniTextSingleLine: {},
  slideTagsText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#707070',
  },
  slideTagsContainer: {
    width: 'auto',
    margin: 0,
    marginEnd: 10,
    marginTop: 10,
    padding: 7,
    paddingHorizontal: 10,
    borderRadius: 5,
    borderColor: '#e0e0e3',
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
  },
  slideBadgeContainer: {
    width: 'auto',
    margin: 0,
    marginEnd: 10,
    marginTop: 0,
    padding: 7,
    paddingHorizontal: 10,
    borderRadius: 5,
    borderColor: '#e0e0e3',
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
  },
  slideMiniImage: {
    width: itemMiniWidth - 22,
    height: itemMiniHeight - 22,
  },
  featuredImage: {
    width: itemFeatureWidth,
    // height: featureItemHeight,
    height: itemFeatureWidth * config.theme.advert.imageHeightRatio,
    borderRadius: 8,
  },
  featuredSlideContainer: {
    height: featureItemHeight,
    width: totalFeatureItemWidth,
    margin: 0,
  },
  advertImage: {
    borderWidth: config.theme.carousel.imageBorder,
    borderColor: config.theme.carousel.imageBorderColor,
    height: advertImageWidth * config.theme.advert.imageHeightRatio,
    width: advertImageWidth,
  },
  photoSlideContainer: {
    height: featureItemHeight,
    width: totalFeatureItemWidth,
    margin: 0,
  },
  photoImage: {
    width: itemFeatureWidth,
    height: featureItemHeight,
  },
  badgeContainer: {
    marginRight: 10,
  },
  badgeBadge: {
    backgroundColor: config.theme.headingTextColor,
    height: 22,
    borderRadius: 30,
  },
  badgeText: {
    paddingHorizontal: 10,
  },
  viewMoreSlide: {
    flex: 1,
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
  },
  viewMoreArrow: {
    borderWidth: 1,
    borderColor: '#cccccc',
    borderRadius: 40,
    padding: 12,
    marginBottom: 16,
  },
  iconBase: {
    width: 24,
    height: 24,
  },
  advertViewMoreSlideContainer: {
    height: itemHeight - 34,
    width: totalItemWidth - 36,
    margin: 0,
    backgroundColor: 'white',
  },
});

export default styles;
